export * from './MailSendingProviderEnumFormGroup';

export * from './MailSenderConfigDtoFormGroup';

export * from './MailSenderSmtpSettingsDtoFormGroup';

export * from './MailSenderGoogleSettingsDtoFormGroup';

export * from './MailSenderOffice365SettingsDtoFormGroup';

export * from './MailSenderTechnicalSettingsDtoFormGroup';

export * from './MailSenderProviderSettingsDtoFormGroup';

export * from './UpdateMailSettingsDtoFormGroup';

export * from './AxovaNasSyncFolderCreatedDtoFormGroup';

export * from './CreateTenantProjectLinkDtoFormGroup';

export * from './PasswordResetTokenFormGroup';

export * from './DocumentSyncSettingsDtoFormGroup';

export * from './TenantProjectLinkSyncSettingsDtoFormGroup';

export * from './AuthenticatorFormGroup';

export * from './ProjectAnlageTypesEnumFormGroup';

export * from './UpdateTenantProjectLinkDtoFormGroup';

export * from './CreateExternalProjectReferenceDtoFormGroup';

export * from './CreateDocumentLinkDtoFormGroup';

export * from './UpdateDocumentLinkDtoFormGroup';

export * from './CreateTenantApiKeyDtoFormGroup';

export * from './CreateTenantApiKeyResponseDtoFormGroup';

export * from './UpdateTenantApiKeyDtoFormGroup';

export * from './CreateTenantDtoFormGroup';

export * from './UpdateTenantDtoFormGroup';

export * from './CreateExternalTaskLinkDtoFormGroup';

export * from './CreateExternalProjectLinkDtoFormGroup';

export * from './UpdateProjectLinkNumberDtoFormGroup';

export * from './UpdateChangelogStatusDtoFormGroup';

export * from './CreateExternalDocumentLinkDtoFormGroup';

export * from './UpdateDocumentV2DtoFormGroup';

export * from './CreateDocumentDtoFormGroup';

export * from './CreateDocumentV2DtoFormGroup';

export * from './UpdateDocumentsMoveToProjectDtoFormGroup';

export * from './SendDocumentsByEmailV2DtoFormGroup';

export * from './UpdateTaskDtoFormGroup';

export * from './UpdateFixedDateDtoFormGroup';

export * from './UpdateMontageplanBlockDatesDtoFormGroup';

export * from './UpdateMontageplanNoteDtoFormGroup';

export * from './ProjectNachfassenDtoFormGroup';

export * from './AddressDtoFormGroup';

export * from './CreateProjectDtoFormGroup';

export * from './UpdateProjectDtoFormGroup';

export * from './UpdateProjectNotesDtoFormGroup';

export * from './SetProjectToSoldAdditionalDiscountDtoFormGroup';

export * from './SetProjectToSoldDtoFormGroup';

export * from './SetProjectToPlannedDtoFormGroup';

export * from './SetProjectToStornoDtoFormGroup';

export * from './SetProjectToStornoV4DtoFormGroup';

export * from './UpdateProjectAnlageUndObjektdatenDtoFormGroup';

export * from './AuthDtoFormGroup';

export * from './GetMailsAndPhonesDtoFormGroup';

export * from './RequestOtpDtoFormGroup';

export * from './VerifyOtpDtoFormGroup';

export * from './UpdatePasswordDtoFormGroup';

export * from './UpdateLanguageDtoFormGroup';

export * from './VerifyOtpV2DtoFormGroup';

export * from './RequestPasswordResetDtoFormGroup';

export * from './ResetPasswordDtoFormGroup';

export * from './CreateLeadFromReservationdDtoFormGroup';

export * from './UpdatePhoneDtoFormGroup';

export * from './UpdateMailDtoFormGroup';

export * from './UpdateContactDtoFormGroup';

export * from './AddPhoneToContactDtoFormGroup';

export * from './AddMailToContactDtoFormGroup';

export * from './CreateContactDtoFormGroup';

export * from './TransformToLeadDtoFormGroup';

export * from './CreateReservationDtoFormGroup';

export * from './UpdateReservationDtoFormGroup';

export * from './VerifyReservationOtpDtoFormGroup';

export * from './SendReservationFeedbackDtoFormGroup';

export * from './VerifyReservationManuallyDtoFormGroup';

export * from './RemoveAttendeeDtoFormGroup';

export * from './UpdateUserDtoFormGroup';

export * from './CreateUserDtoFormGroup';

export * from './AddRoletypeDtoFormGroup';

export * from './RemoveRoletypeDtoFormGroup';

export * from './UpdateNotesDtoFormGroup';

export * from './CreateNotificationDtoFormGroup';

export * from './UpdateNotificationDtoFormGroup';

export * from './CreatePhoneDtoFormGroup';

export * from './UpdateTimerecordBalanceDtoFormGroup';

export * from './ActualTargetAndSaldoFormGroup';

export * from './UpdateUseremploymentDtoFormGroup';

export * from './CreateUseremploymentDtoFormGroup';

export * from './UpdateCalculationitemsGroupSortableRankDtoFormGroup';

export * from './CreateCalculationitemsGroupDtoFormGroup';

export * from './UpdateCalculationitemsGroupDtoFormGroup';

export * from './SetCalculationitemsDeliveredDtoFormGroup';

export * from './UpdateCalculationitemSortableRankDtoFormGroup';

export * from './UpdateCalculationitemPropertyDtoFormGroup';

export * from './UpdateCalculationitemDtoFormGroup';

export * from './CreateCalculationitemDtoFormGroup';

export * from './UpdateResultFormGroup';

export * from './AddCalculationitemForSaleDtoFormGroup';

export * from './CreateDiscountCalculationitemDtoFormGroup';

export * from './CreateStandardtaskDtoFormGroup';

export * from './UpdateStandardtaskDtoFormGroup';

export * from './CreateCalculationTemplateDtoFormGroup';

export * from './CreateCalculationTemplateFromCalculationDtoFormGroup';

export * from './UpdateCalculationTemplateItemSortOrderDtoFormGroup';

export * from './CreateCalculationTemplateGroupDtoFormGroup';

export * from './UpdateCalculationTemplateGroupDtoFormGroup';

export * from './CreateCalculationTemplateItemDtoFormGroup';

export * from './UpdateCalculationTemplateItemDtoFormGroup';

export * from './CreateCalculationTemplateVariableDtoFormGroup';

export * from './UpdateCalculationTemplateVariableDtoFormGroup';

export * from './UpdateCalculationTemplateDtoFormGroup';

export * from './CreatePriceDtoFormGroup';

export * from './CreatePriceTierDtoFormGroup';

export * from './UpdatePriceTierDtoFormGroup';

export * from './UpdateCalculationBuildingserviceEntriesDtoFormGroup';

export * from './CreateBuildingserviceDtoFormGroup';

export * from './UpdateBuildingserviceDtoFormGroup';

export * from './WegspesenDetailsFormGroup';

export * from './WegspesenDtoFormGroup';

export * from './PerformanceMontageTotalsDtoFormGroup';

export * from './SendEmailToAgentsDtoFormGroup';

export * from './AccountingSettingsFormGroup';

export * from './UpdateAccountingSettingsDtoFormGroup';

export * from './CreateLedgerAccountDtoFormGroup';

export * from './UpdateLedgerAccountDtoFormGroup';

export * from './CreateCostCentreDtoFormGroup';

export * from './UpdateCostCentreDtoFormGroup';

export * from './CreateTaxCodeDtoFormGroup';

export * from './UpdateTaxCodeDtoFormGroup';

export * from './CreateAccountingPartnerDtoFormGroup';

export * from './CreateExternalSupplierDtoFormGroup';

export * from './ExternalSupplierCreatedDtoFormGroup';

export * from './UpdateAccountingPartnerDtoFormGroup';

export * from './CreatePaymentConditionDtoFormGroup';

export * from './UpdatePaymentConditionDtoFormGroup';

export * from './CreateExpensePaymentMethodDtoFormGroup';

export * from './UpdateExpensePaymentMethodDtoFormGroup';

export * from './ConnectorTargetEntityEnumFormGroup';

export * from './UpdateConnectorConfigDtoFormGroup';

export * from './UpdateConnectorCredentialsDtoFormGroup';

export * from './CreateAbsenceDtoFormGroup';

export * from './UpdateAbsenceDtoFormGroup';

export * from './UpdateAbsenceV2DtoFormGroup';

export * from './CreateAbsenceV2DtoFormGroup';

export * from './AddDocumentDtoFormGroup';

export * from './RemoveDocumentDtoFormGroup';

export * from './CreateTaskDtoFormGroup';

export * from './CreateProjecttaskFromStandardtaskDtoFormGroup';

export * from './UpdateTaskSortableRankDtoFormGroup';

export * from './GetTasksByProjectIdsDtoFormGroup';

export * from './GetTasksForProjectIdsDtoFormGroup';

export * from './TaskChangeRequestStatusEnumFormGroup';

export * from './TaskChangeRequestFormGroup';

export * from './ResolveTaskChangeRequestDtoFormGroup';

export * from './CreateContactPersonDtoFormGroup';

export * from './UpdateContactPersonDtoFormGroup';

export * from './SendMailDtoFormGroup';

export * from './SendLeadDtoFormGroup';

export * from './SendMailTemplateMetaFormGroup';

export * from './SendMailFromTemplateDtoFormGroup';

export * from './AuthenticateWithSecretDtoFormGroup';

export * from './UpdateWelcomescreenDtoFormGroup';

export * from './CreateDebtorDtoFormGroup';

export * from './UpdateDebtorDtoFormGroup';

export * from './CreateEquipmentDtoFormGroup';

export * from './UpdateEquipmentDtoFormGroup';

export * from './AddOrRemoveDocumentToEquipmentDtoFormGroup';

export * from './CreateInteractionDtoFormGroup';

export * from './CreateInteractionActivityDtoFormGroup';

export * from './CreateInteractionNoteDtoFormGroup';

export * from './CreateInteractionTaskDtoFormGroup';

export * from './UpdateInteractionDtoFormGroup';

export * from './UpdateTicketDtoFormGroup';

export * from './CreateTicketDtoFormGroup';

export * from './CreateTicketCategoryDtoFormGroup';

export * from './UpdateTicketCategoryDtoFormGroup';

export * from './CreateLocationDtoFormGroup';

export * from './UpdateLocationDtoFormGroup';

export * from './CreateMailDtoFormGroup';

export * from './UpdateItemDtoFormGroup';

export * from './CreateItemDtoFormGroup';

export * from './SendMessagePersonalDtoFormGroup';

export * from './SendMessageAttachmentDtoFormGroup';

export * from './SendMessageDtoFormGroup';

export * from './CreateDocumenttypeDtoFormGroup';

export * from './UpdateDocumenttypeDtoFormGroup';

export * from './CreateProjectrevenueDtoFormGroup';

export * from './AddStandardTaskGroupsToProjectDtoFormGroup';

export * from './CreateTimerecordHolidayDtoFormGroup';

export * from './UpdateTimerecordHolidayDtoFormGroup';

export * from './UpdateStocklocationDtoFormGroup';

export * from './CreateStocklocationDtoFormGroup';

export * from './CreateProjectCheckRuleDtoFormGroup';

export * from './UpdateSortOrderProjectCheckRulesDtoFormGroup';

export * from './UpdateProjectCheckRuleDtoFormGroup';

export * from './CreateDocumentTemplateDtoFormGroup';

export * from './UpdateDocumentTemplateDtoFormGroup';

export * from './UploadDocumentTemplateDtoFormGroup';

export * from './CreateTimerecorddetailDtoFormGroup';

export * from './UpdateTimerecorddetailDtoFormGroup';

export * from './ReapplyPauseTemplateResultDtoFormGroup';

export * from './CreateTimeBlockTemplateDtoFormGroup';

export * from './UpdateTimeBlockTemplateDtoFormGroup';

export * from './CreateTimeBlockTemplateEntryDtoFormGroup';

export * from './UpdateTimeBlockTemplateEntryDtoFormGroup';

export * from './AddressSearchResultDtoFormGroup';

export * from './CreateAgentDtoFormGroup';

export * from './UpdateAgentDtoFormGroup';

export * from './CreatePushNotificationTokenDtoFormGroup';

export * from './CreateAppDeviceDtoFormGroup';

export * from './CreateAudienceDtoFormGroup';

export * from './UpdateAudienceDtoFormGroup';

export * from './BudgetAccountTypeEnumFormGroup';

export * from './BudgetIstSourceEnumFormGroup';

export * from './BudgetSollSourceEnumFormGroup';

export * from './BudgetAccountFormGroup';

export * from './BudgetEntryFormGroup';

export * from './CreateBudgetAccountDtoFormGroup';

export * from './UpdateBudgetAccountSortableRankItemDtoFormGroup';

export * from './UpdateBudgetAccountDtoFormGroup';

export * from './UpsertBudgetEntryItemDtoFormGroup';

export * from './UpsertBudgetEntriesDtoFormGroup';

export * from './DistributeBudgetDtoFormGroup';

export * from './BudgetReportMonthValueDtoFormGroup';

export * from './BudgetReportRowDtoFormGroup';

export * from './BudgetReportResponseDtoFormGroup';

export * from './BudgetInterDivisionDetailDtoFormGroup';

export * from './BudgetInterDivisionDetailsResponseDtoFormGroup';

export * from './BudgetSalaryEmployeeDetailDtoFormGroup';

export * from './BudgetSalaryDetailsResponseDtoFormGroup';

export * from './CreateBusinessdivisionDtoFormGroup';

export * from './UpdateBusinessdivisionDtoFormGroup';

export * from './CreateBusinessunitDtoFormGroup';

export * from './UpdateBusinessunitDtoFormGroup';

export * from './CreateCommentDtoFormGroup';

export * from './CreateNewsDtoFormGroup';

export * from './UpdateNewsDtoFormGroup';

export * from './AddOrRemoveDocumentToNewsDtoFormGroup';

export * from './CreateContainerDtoFormGroup';

export * from './CreateContainertypeDtoFormGroup';

export * from './UpdateContainertypeDtoFormGroup';

export * from './CreateDocumentsubtypeDtoFormGroup';

export * from './UpdateDocumentsubtypeDtoFormGroup';

export * from './CreateElectricalMeasurementDtoFormGroup';

export * from './UpdateElectricalMeasurementDtoFormGroup';

export * from './CreateEquipmentintervalDtoFormGroup';

export * from './UpdateEquipmentintervalDtoFormGroup';

export * from './CreateEquipmentlogDtoFormGroup';

export * from './CreateEquipmentlogCheckinDtoFormGroup';

export * from './CreateEquipmentlogCheckoutDtoFormGroup';

export * from './CreateEquipmentlogDefektDtoFormGroup';

export * from './CreateEquipmentlogReparaturDtoFormGroup';

export * from './UpdateEquipmentlogDtoFormGroup';

export * from './CreateEquipmentlogtypeDtoFormGroup';

export * from './UpdateEquipmentlogtypeDtoFormGroup';

export * from './CreateEquipmenttypeDtoFormGroup';

export * from './UpdateEquipmenttypeDtoFormGroup';

export * from './CreateEventInvitationPublicDtoFormGroup';

export * from './CreateEventInvitationDtoFormGroup';

export * from './CreateEventRegistrationSelectedOptionDtoFormGroup';

export * from './UpdateEventInvitationAdminDtoFormGroup';

export * from './UpdateEventInvitationOrganisatorDtoFormGroup';

export * from './SendInvitationLinkDtoFormGroup';

export * from './UpdateEventRegistrationSelectedOptionDtoFormGroup';

export * from './CreateEventInvitationV2DtoFormGroup';

export * from './UpdateEventInvitationV2DtoFormGroup';

export * from './CreateEventRegistrationOptionDtoFormGroup';

export * from './CreateEventRegistrationOptionGroupDtoFormGroup';

export * from './UpdateEventRegistrationOptionDtoFormGroup';

export * from './UpdateEventRegistrationOptionGroupDtoFormGroup';

export * from './CreateEventDtoFormGroup';

export * from './UpdateEventDtoFormGroup';

export * from './AddOrRemoveDocumentToEventDtoFormGroup';

export * from './CreateItemGroupDtoFormGroup';

export * from './UpdateItemGroupDtoFormGroup';

export * from './CreateVendorContactFromCatalogDtoFormGroup';

export * from './VoucherRecognitionAddressDtoFormGroup';

export * from './UpdateVoucherDtoFormGroup';

export * from './CreateLeadcategoryDtoFormGroup';

export * from './UpdateLeadcategoryDtoFormGroup';

export * from './CreateLeadsubcategoryDtoFormGroup';

export * from './UpdateLeadsubcategoryDtoFormGroup';

export * from './CreateMeetingAgendaItemDtoFormGroup';

export * from './UpdateMeetingAgendaItemDtoFormGroup';

export * from './CreateMeetingDecisionDtoFormGroup';

export * from './UpdateMeetingDecisionDtoFormGroup';

export * from './CreateMeetingParticipantDtoFormGroup';

export * from './UpdateMeetingParticipantDtoFormGroup';

export * from './CreateMeetingDtoFormGroup';

export * from './UpdateMeetingDtoFormGroup';

export * from './AddOrRemoveDocumentToMeetingDtoFormGroup';

export * from './CreateProspectDtoFormGroup';

export * from './UpdateProspectDtoFormGroup';

export * from './ChatMessageTypeEnumFormGroup';

export * from './CreateDirectChatDtoFormGroup';

export * from './CreateGroupChatDtoFormGroup';

export * from './UpdateChatMessageDtoFormGroup';

export * from './UpdateChatDtoFormGroup';

export * from './AddChatMembersDtoFormGroup';

export * from './MarkChatReadDtoFormGroup';

export * from './CreateChatMessageDtoFormGroup';

export * from './CreateMeetingTypeDtoFormGroup';

export * from './UpdateMeetingTypeDtoFormGroup';

export * from './CreateMeetingTemplateAgendaItemDtoFormGroup';

export * from './UpdateMeetingTemplateAgendaItemDtoFormGroup';

export * from './CreateMeetingTemplateParticipantDtoFormGroup';

export * from './UpdateMeetingTemplateParticipantDtoFormGroup';

export * from './UpdateMessagingTemplateDtoFormGroup';

export * from './CreateMessagingTemplateDtoFormGroup';

export * from './CreateProjectdossierTemplateDtoFormGroup';

export * from './UpdateSortOrderProjectdossierTemplatesDtoFormGroup';

export * from './UpdateProjectdossierTemplateDtoFormGroup';

export * from './CreateIndividualProjectdossierDtoFormGroup';

export * from './UpdateIndividualProjectdossierDtoFormGroup';

export * from './UpdateProjectdossierHiddenDocumentsDtoFormGroup';

export * from './UpdateProjectdossierDocumentselectionDtoFormGroup';

export * from './CreateProjectShareDtoFormGroup';

export * from './UpdateProjectShareDtoFormGroup';

export * from './CreateProjectShareSessionDtoFormGroup';

export * from './ProjectSharePublicAddressDtoFormGroup';

export * from './UpdateEventInvitationDtoFormGroup';

export * from './UpdateProfileDtoFormGroup';

export * from './UpdateUsertrainingDtoFormGroup';

export * from './CreateUsertrainingDtoFormGroup';

export * from './CreateOrdercartFromCalculationitemsDtoFormGroup';

export * from './UpdateOrdercartDtoFormGroup';

export * from './UpdateOrderDtoFormGroup';

export * from './AddOrderStockPositionDtoFormGroup';

export * from './UpdatePermissionDtoFormGroup';

export * from './CreatePermissionDtoFormGroup';

export * from './CreatePersonnelFileEntryDtoFormGroup';

export * from './UpdatePersonnelFileEntryDtoFormGroup';

export * from './CreatePersonnelFileCategoryDtoFormGroup';

export * from './UpdatePersonnelFileCategoryDtoFormGroup';

export * from './UpdatePowermembershipDtoFormGroup';

export * from './CreatePowermembershipDtoFormGroup';

export * from './UpdateProductGroupDtoFormGroup';

export * from './CreateProductGroupDtoFormGroup';

export * from './CreatedReferralCodeDtoFormGroup';

export * from './UpdateReservationteamDtoFormGroup';

export * from './CreateReservationteamDtoFormGroup';

export * from './AddUserDtoFormGroup';

export * from './RemoveUserDtoFormGroup';

export * from './AddContainertypeDtoFormGroup';

export * from './RemoveContainertypeDtoFormGroup';

export * from './UpdateReservationtypeDtoFormGroup';

export * from './CreateReservationtypeDtoFormGroup';

export * from './UpdateRoletypeDtoFormGroup';

export * from './CreateRoletypeDtoFormGroup';

export * from './AddPermissionDtoFormGroup';

export * from './RemovePermissionDtoFormGroup';

export * from './UpdateScreencomponentDtoFormGroup';

export * from './CreateScreencomponentDtoFormGroup';

export * from './SetAlwaysOnDtoFormGroup';

export * from './UpdateScreendeviceDtoFormGroup';

export * from './CreateScreendeviceDtoFormGroup';

export * from './UpdateScreenslideDtoFormGroup';

export * from './CreateScreenslideDtoFormGroup';

export * from './SelfServiceProjectAsRequestedDtoFormGroup';

export * from './CreateProjectHouseSideDtoFormGroup';

export * from './UpdateProjectHouseSideDtoFormGroup';

export * from './CreateTaskChangeRequestDtoFormGroup';

export * from './CreateTaskChangeRequestsBulkDtoFormGroup';

export * from './UpdateSupplierDtoFormGroup';

export * from './CreateSupplierDtoFormGroup';

export * from './UpdateSupplierFromLindasDtoFormGroup';

export * from './CreateGameDtoFormGroup';

export * from './UpdateTagDtoFormGroup';

export * from './CreateTagDtoFormGroup';

export * from './RemoveTeammembershipDtoFormGroup';

export * from './CreateTeamDtoFormGroup';

export * from './UpdateTeamDtoFormGroup';

export * from './UpdateTimerecordDtoFormGroup';

export * from './CreateTaskTabDtoFormGroup';

export * from './UpdateTaskTabDtoFormGroup';

export * from './CreateTodoDtoFormGroup';

export * from './UpdateTodoDtoFormGroup';

export * from './CreateTrainingtypeDtoFormGroup';

export * from './UpdateTrainingtypeDtoFormGroup';

export * from './CreateUploadDtoFormGroup';

export * from './CreateUploadsDtoFormGroup';

export * from './CreateOrUpdateUserconfigurationDtoFormGroup';

export * from './CreateWorkflowDocumenttypeDtoFormGroup';

export * from './CreateWorkflowStandardtaskDtoFormGroup';

export * from './CreateWorkflowProjectDtoFormGroup';

export * from './UpdateWorkflowDocumenttypeDtoFormGroup';

export * from './UpdateWorkflowStandardtaskDtoFormGroup';

export * from './UpdateWorkflowProjectDtoFormGroup';

export * from './CreateWorkflowtaskDtoFormGroup';

export * from './UpdateWorkflowtaskDtoFormGroup';

export * from './UpdateWorkflowtaskSortableRankDtoFormGroup';

